<template>
  <div class="vol">
    <div
      class="vol-btn"
      @mouseenter="showRange"
      @mouseleave="mouseleave"
    >
      <iconfont
        v-show="value === min"
        name="#icon11-14yinliangjingyinanniu"
        font-size="14px"
      ></iconfont>
      <iconfont
        v-show="value !== min"
        name="#icon11-13yinlianganniu"
        font-size="14px"
      ></iconfont>
    </div>
    <div
      v-show="rangeVisible || isMoving"
      class="range-bar"
      @mouseenter="showRange"
      @mouseleave="mouseleave"
    >
      <div
        ref="track"
        class="track"
      >
        <div
          class="bar"
          :style="{ height: `${currentPos * 100}%` }"
        ></div>
        <div
          class="thumb"
          :style="{ bottom: `${currentPos * 100}%` }"
          :draggable="false"
          @mousedown.stop.prevent="startMove"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Number,
      default: 0.5
    },
    min: {
      type: Number,
      default: 0
    },
    max: {
      type: Number,
      default: 1
    },
    step: {
      type: Number,
      default: 0.01
    }
  },
  data() {
    return {
      rangeVisible: false,
      timer: null,
      delay: 200,
      trackStart: 0,
      trackSize: 0,
      isMoving: false
    };
  },
  computed: {
    currentPos() {
      return (this.value - this.min) / (this.max - this.min);
    }
  },
  watch: {
    rangeVisible(val) {
      if (val) {
        this.$nextTick(() => {
          this.initPos();
        });
      }
    }
  },
  mounted() {
    this.initPos();
  },
  methods: {
    initPos() {
      let rect = this.$refs.track.getBoundingClientRect();
      this.trackStart = rect.bottom;
      this.trackSize = rect.height;
    },
    showRange() {
      clearTimeout(this.timer);
      this.rangeVisible = true;
    },
    mouseleave() {
      this.timer = setTimeout(() => {
        this.rangeVisible = false;
      }, this.delay);
    },
    startMove() {
      this.isMoving = true;
      window.addEventListener('mousemove', this.moving);
      window.addEventListener('mouseup', this.endMove);
    },
    moving(e) {
      let progress = -(e.clientY - this.trackStart);
      progress = progress / this.trackSize;
      progress = progress * (this.max - this.min);
      let value = Math.round(progress / this.step) * this.step;
      value = value.toFixed(2) - 0;
      value = Math.max(Math.min(value, this.max), this.min);
      this.$emit('input', value);
    },
    endMove() {
      window.removeEventListener('mousemove', this.moving);
      window.removeEventListener('mouseup', this.endMove);
      this.isMoving = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.vol {
  position: relative;
  width: 30px;
  height: 30px;
}

.vol-btn {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 30px;
  height: 30px;
  background: #ffffff;
  border: 1px solid #ffffff;
  box-shadow: 0px 2px 5px 0px rgba(124, 124, 124, 0.13);
  border-radius: 15px;
  color: #2f58fe;
}

@media only screen and (max-width: 1600px) {
  .vol-btn {
    width: 26px;
    height: 26px;
  }
}

.range-bar {
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  bottom: calc(100% + 6px);
  left: 50%;
  transform: translateX(-50%);
  width: 20px;
  height: 137px;
  background-color: rgba(#000, 0.1);
  border-radius: 10px;
}
.track {
  position: relative;
  width: 4px;
  height: 113px;
  background: #ffffff;
  border-radius: 2px;
}
.bar {
  position: absolute;
  bottom: 0;
  width: 4px;
  background: #2f58fe;
  border-radius: 2px;
}
.thumb {
  width: 8px;
  height: 8px;
  background: #2f58fe;
  border-radius: 50%;
  position: absolute;
  bottom: 0;
  left: -2px;
  margin-bottom: -4px;
  cursor: pointer;
  user-select: none;
}
</style>
